/**
 * @param variables {{ajaxUrls: {login: string}, googleLogin: {isEnabled: boolean}, googleLoaded: boolean }}
 */
const LoginController = ['$scope', '$http', '$lazyScripts', function($scope, $http, $lazyScripts) {
    $scope.form = {
        email: '',
        password: '',
        remember: true,
        captcha: null,
        errors: [],
        success: false,
        isLoading: false,
        googleLogin: window.variables.googleLogin,
        googleLoaded: false,

        async send(token) {
            $scope.form.isLoading = true;

            const params = {
                FrontendLoginForm : {
                    email: $scope.form.email,
                    password: $scope.form.password,
                    remember: $scope.form.remember,
                    captcha: token,
                },
            };

            const response = await $http.post(window.variables.ajaxUrls.login, params, {
                headers: {'X-Requested-With': 'XMLHttpRequest'},
            });

            if (response.data.success === true) {
                window.location.reload();
            } else {
                $scope.form.errors = Object.values(response.data.errors).flat();
                $scope.form.isLoading = false;
            }
        }
    };

    $lazyScripts.loadGoogleLogin().then(() => {
        $scope.form.googleLoaded = true;
        $scope.$apply();
    });
}];

export default LoginController;
